import { Box, Button, TextField, makeStyles } from '@material-ui/core';
import React, { FC, ReactNode, useState } from 'react';

interface editTextProps {
  key?: number;
  type: string;
  children?: ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  menuTitle: {
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem'
  }
}));

const EditLayout: FC<editTextProps> = ({ key, type, children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.menuTitle}>
        {type
          .toUpperCase()
          .replaceAll('_', ' ')
          .replaceAll(/[0-9]/g, '')}
      </Box>
      {children}
    </Box>
  );
};

export default EditLayout;
